import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import LocaleModel from 'coreClasses/locales/LocaleModel';
import {IEcommerceData} from '../../IGoogleTagManager';
import ECommerceEventModel from './EcommerceEventModel';
import ECommerceProductHitModel from './models/EcommerceProductHitModel';

/**
 * Represents ECommerceProductListLoadEventModel
 */
export default class ECommerceProductListLoadEventModel extends ECommerceEventModel {
	public ecommerce: IEcommerceData;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const currentLocale: LocaleModel = this.managerRepository.getLocalesMgr().getCurrentLocale();
		const activeTabId = localStorage.getItem('activeTabId');

		this.ecommerce = {
			currencyCode: currentLocale.getCurrencyCode(),
			impressions: data?.productsData?.map((productData) => {
				return {...new ECommerceProductHitModel(productData, this.getSource())};
			})
		};

		if (activeTabId) {
			this.ecommerce.activeTabId = activeTabId;
		}
	}
};
